// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Segment } from "semantic-ui-react";
// import CanvasJSReact from "../../../ThirdParty/CanvasJS/canvasjs.react";
import _ from "lodash";
import moment from "moment";
import * as timecourseCalculations from "../../../Lumber/AreaUnderTheCurve";
import AFPlot from "../../../Lumber/Plotting/AFPlotly.tsx";
const LineChart = ({ data, analysisName, cumulativeGDUs, gduByDay, useGDU, hideLineCharts }) => {
	// const CanvasJSChart = CanvasJSReact.CanvasJSChart;
	const DATE_FORMAT = "M/D";

	//-- Data
	const [groupedTreatments, setGroupedTreatments] = useState([]);
	// const [chartOptions, setChartOptions] = useState({});
	const [chartData, setChartData] = useState([]);
	const [cumulativeGDU, setCumulativeGDU] = useState([]);
	const [noData, setNoData] = useState(true);

	useEffect(() => {
		if (data.length > 0) {
			setNoData(false);
			let treatments = _.groupBy(data, "trialTreatmentId");
			setGroupedTreatments(treatments);
			if (gduByDay) {
				let calculatedCumulativeGDU = timecourseCalculations.calculateCumulativeGdu(
					_.find(treatments, (t) => {
						return t !== undefined;
					}),
					gduByDay,
				);
				setCumulativeGDU(calculatedCumulativeGDU);
			}
		} else {
			setNoData(true);
		}
	}, [data]);

	useEffect(() => {
		if (cumulativeGDUs) {
			setCumulativeGDU(cumulativeGDUs);
		}
	}, [cumulativeGDUs]);

	useEffect(() => {
		if (useGDU) {
			createChartForGDU();
		} else {
			createChartForDays();
		}
	}, [groupedTreatments, useGDU, cumulativeGDU]);

	function createChartForGDU() {
		let dataObject = [];
		_.map(groupedTreatments, (treatments, trialIndex) => {
			let dataPoints = [];
			_.map(treatments, (treatment) => {
				let gdu = _.find(cumulativeGDU, (g) => {
					return g.flightId === treatment.flightId;
				});
				if (gdu === undefined) {
					if (treatment?.isPlantFlight) {
						gdu = [];
						gdu.gdu = 0;
					} else if (treatment?.isHarvestFlight) {
						gdu = cumulativeGDU[cumulativeGDU.length - 1];
					}
				}
				const data = {
					//convert to number when you calculate this value
					x: Number(gdu?.gdu ?? 0),
					y: hideLineCharts ? "" : treatment.trialAnalysisResultAverageValue,
					label: gdu?.gdu.toString(),
				};
				dataPoints.push(data);
			});

			let data = {
				x: dataPoints.map((p) => p.x),
				y: dataPoints.map((p) => p.y),
				text: dataPoints.map((p) => p.label),
				name: trialIndex,
				type: "scatter",
				mode: "lines+markers",
				hovertemplate: `${trialIndex} - %{text}: %{y}<extra></extra>`,
			};
			dataObject.push(data);
		});

		// let opt = {
		// 	animationEnabled: true,
		// 	theme: "light2",
		// 	axisY: {
		// 		title: analysisName,
		// 		includeZero: false
		// 	},
		// 	legend: {
		// 		verticalAlign: "top",
		// 		horizontalAlign: "center",
		// 		dockInsidePlotArea: false
		// 	},
		// 	data: dataObject
		// };
		setChartData(dataObject);
	}

	function createChartForDays() {
		let dataObject = [];
		_.map(groupedTreatments, (treatments, trialIndex) => {
			let dataPoints = [];
			_.map(treatments, (treatment) => {
				const dateUtc = treatment.flightDate + "Z";
				let date = new Date(dateUtc);
				date.setHours(0, 0, 0, 0);
				const data = {
					x: new Date(date),
					y: hideLineCharts ? "" : treatment.trialAnalysisResultAverageValue,
					label: moment(treatment.flightDate).local().format(DATE_FORMAT),
				};
				dataPoints.push(data);
			});

			let data = {
				x: dataPoints.map((p) => p.x),
				y: dataPoints.map((p) => p.y),
				text: dataPoints.map((p) => p.label),
				name: trialIndex,
				type: "scatter",
				mode: "lines+markers",
				hovertemplate: `${trialIndex} - %{text}: %{y}<extra></extra>`,
			};
			dataObject.push(data);
		});

		// let opt = {
		// 	animationEnabled: true,
		// 	theme: "light2",
		// 	backgroundColor: "transparent",
		// 	axisX: { valueFormatString: DATE_FORMAT },
		// 	axisY: {
		// 		title: analysisName,
		// 		includeZero: false
		// 	},
		// 	legend: {
		// 		verticalAlign: "top",
		// 		horizontalAlign: "center",
		// 		dockInsidePlotArea: false
		// 	},
		// 	data: dataObject
		// };
		setChartData(dataObject);
	}

	const chartLayout = {
		showlegend: true,
		legend: {
			orientation: "h",
			xanchor: "center",
			x: 0.5,
			y: Math.ceil(chartData.length / 10) * 20 + 1.1,
		},
		height: 400,
		// width: rootStyle.width ?? 340,
		// autosize: false,
		// hovermode: false,
		clickmode: "none",
		dragmode: false,
		margin: {
			b: 15,
			l: 60,
			r: 0,
			t: Math.ceil(chartData.length / 10) * 20,
		},
		xaxis: {
			showgrid: false,
			...(useGDU ? {} : { tickformat: "%-m/%-d" }),
		},
		yaxis: {
			autorange: true,
			title: {
				text: analysisName,
			},
		},
		paper_bgcolor: "#fff0",
		plot_bgcolor: "#fff0",
		// barmode: "overlay",
		// bargap: 0
	};

	const chartConfig = {
		displayModeBar: false, // Hides the modebar
		scrollZoom: false, // Disables scroll zooming
		dragMode: false, // Disables panning,
		responsive: true,
	};

	return (
		<Segment basic style={{ borderRadius: "8px", border: "1px solid var(--border)", background: "#ffffffe6" }}>
			{noData == true ? (
				<p> There is no data selected for the line chart.</p>
			) : (
				<AFPlot
					data={chartData}
					layout={chartLayout}
					config={chartConfig}
					style={{ width: "100%", position: "relative", height: "400px" }}
				/>
				// <CanvasJSChart
				// 	options={chartOptions}
				// 	containerProps={{ width: "100%", position: "relative", height: "400px" }}
				// />
			)}
		</Segment>
	);
};

LineChart.propTypes = {
	data: PropTypes.array.isRequired,
	analysisName: PropTypes.string,
	cumulativeGDUs: PropTypes.array,
	gduByDay: PropTypes.array,
	useGDU: PropTypes.bool,
	hideLineCharts: PropTypes.bool,
};

export default LineChart;
